/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon24Solid = forwardRef('TimeClockMoveBackIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.32 4.363a7.75 7.75 0 0 0-7.658 3.178H7.5a1.25 1.25 0 1 1 0 2.5H3a1.25 1.25 0 0 1-1.25-1.25V4.037a1.25 1.25 0 0 1 2.5 0v1.255A10.249 10.249 0 1 1 2.632 16.16a1.25 1.25 0 0 1 2.285-1.015A7.75 7.75 0 1 0 13.32 4.363Z" }),
        React.createElement("path", { d: "M11.75 6.063c.69 0 1.25.56 1.25 1.25v3.948a.25.25 0 0 0 .138.223l3.296 1.648a1.25 1.25 0 1 1-1.118 2.236L12.02 13.72a2.75 2.75 0 0 1-1.52-2.46V7.314c0-.69.56-1.25 1.25-1.25Z" })));
});
